import { Component, Input, EventEmitter, Output } from '@angular/core';
import * as debug from 'debug';
import * as _ from 'lodash';
import * as turf from '@turf/turf';
import * as $ from 'jquery';
import { UserProvider } from '../../providers/user/user';
import { GeolocationProvider } from '../../providers/geolocation/geolocation';
import { PlaceServiceProvider } from '../../providers/trip-service/place-service';
import { GoogleProvider } from '../../providers/google/google';
import { TripService } from '../../providers/trip-service/trip-service';
import { ToolsProvider } from '../../providers/tools/tools';

@Component({
  selector: 'karma-miles-instructions',
  templateUrl: 'karma-miles-instructions.html',
})
export class karmaMilesInstructionsComponent {
  log = debug('app:karmaMilesInstructionsComponent');

@Output() closeKarmaInstructions = new EventEmitter();

  engagements = [
    {
    icon:'assets/imgs/karmaEarningIcons/parking.svg',
    title:'Update Parking Status',
    karma:10, 
  },
    {
      icon:'assets/imgs/karmaEarningIcons/weightStation.svg',
    title:'Update Weight Station Status',
    karma:10, 
  },
    {
      icon:'assets/imgs/karmaEarningIcons/mapPointer&Check.svg',
    title:'Leave A Place Review (+Photo)',
    karma:10, 
  },
    {
      icon:'assets/imgs/karmaEarningIcons/mapPointer&Check.svg',
    title:'Leave A Place Review',
    karma:3, 
  },
    {
      icon:'assets/imgs/karmaEarningIcons/turnSign.svg',
    title:'Plan A Trip',
    karma:1, 
  },
    {
      icon:'assets/imgs/karmaEarningIcons/blueComment.svg',
    title:'Leave A Comment',
    karma:1, 
  },
    {
      icon:'assets/imgs/karmaEarningIcons/blueShare.svg',
    title:'Share A Post',
    karma:1, 
  },
]

  constructor(
    public userService: UserProvider,
    public geolocation: GeolocationProvider,
    public placesService: PlaceServiceProvider,
    public google: GoogleProvider,
    public tripService: TripService,
    public tools: ToolsProvider
  ) {}
}



// WEBPACK FOOTER //
// ./src/components/karma-miles-instructions/karma-miles-instructions.ts